export const isNullish = (v: unknown): v is null | undefined =>
  v === null || v === undefined
